const $ = jQuery.noConflict();
/* eslint-disable */
'use strict';
const searchRates = {
	$domSearchInput: $('.js-search-rate'),
	$domSearchBtn: $('.js-search-rate-btn'),
	$domSearchLetter: $('.js-table-block-letter'),
	$domTableBlock: $('.js-table-block'),
	$domNoResults: $('.js-table-no-results'),
	$domLoader: $('.js-table-loader'),

	/**
	 * @desc Initialize
	 */
	init: function() {
		if (searchRates.$domTableBlock.length) {
			this.submitSearchRateInput();
			this.searchRatesByLetter();
			this.defaultLoad();
		}
	},

	/**
	 * @desc Default search load
	 */
	defaultLoad: function() {
		const params = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop),
		});
		const letterValue = params.rates;
		const searchValue = params.search;

		if (letterValue) {
			this.ajaxRequest('search_rates_by_letter', letterValue);
			$(`.js-table-block-letter[data-letter="${letterValue}"]`).addClass('is-active');
		}

		if (searchValue) {
			searchRates.$domSearchInput.val(searchValue);
			this.ajaxRequest('search_rates_by_name', searchValue);
			this.addQuery('search', searchValue);
		}

		if (!letterValue && !searchValue) {
			$('.js-table-block-letter[data-letter="a"]').trigger('click');
		}
	},

	/**
	 * @desc Search posts by input
	 */
	searchRatesByInput: function() {
		const searchValue = searchRates.$domSearchInput.val().trim();
		this.ajaxRequest('search_rates_by_name', searchValue);
		searchRates.$domSearchLetter.removeClass('is-active');
		this.addQuery('search', searchValue);
	},

	submitSearchRateInput: function() {
		searchRates.$domSearchBtn.on('click', (e) => {
			e.preventDefault();
			searchRates.searchRatesByInput();
		});
		$(document).on('keypress', function(e) {
			if(e.which === 13 && searchRates.$domSearchInput.is(':focus')) {
				searchRates.searchRatesByInput();
			}
		});
	},

	/**
	 * @desc Search posts by letter
	 */
	searchRatesByLetter: function() {
		searchRates.$domSearchLetter.on('click', (e) => {
			e.preventDefault();
			const $currentItem = $(e.currentTarget);
			const letter = $currentItem.data('letter');
			searchRates.$domSearchLetter.removeClass('is-active');
			$currentItem.addClass('is-active');
			this.ajaxRequest('search_rates_by_letter', letter);
			this.addQuery('rates', letter);
		});
	},

	/**
	 * @desc Add query to url
	 */
	addQuery: function(queryTerm, queryResult) {
		if (queryTerm) {
			history.replaceState(null, null, `?${queryTerm}=${queryResult}`);
		}
	},

	/**
	 * @desc AJAX request
	 */
	ajaxRequest: function(action, searchValue) {
		searchRates.$domLoader.addClass('active');
		searchRates.$domNoResults.removeClass('active');
		let data = {
			action: action,
			// eslint-disable-next-line camelcase
			search_value: searchValue,
		};

		$.ajax({
			method: 'POST',
			// eslint-disable-next-line no-undef
			url: mongotelAjax.ajaxUrl,
			data: data,
			success: function(response) {
				if (response.data.posts_counter > 0) {
					searchRates.$domTableBlock.empty();
					$.each(response.data.posts, function(key, post) {
						searchRates.$domTableBlock.append(
							`<div class="table-block__bottom-table-body-row">
							<span class="table-block__bottom-table-body-row-text table-block__bottom-table-body-row-dest">${post.post_title}</span>
							<span class="table-block__bottom-table-body-row-text table-block__bottom-table-body-row-pref">${post.rate_prefix}</span>
							<span class="table-block__bottom-table-body-row-text table-block__bottom-table-body-row-rate">${post.rate_price}</span>
						</div>`
						);
					});
				} else {
					searchRates.$domTableBlock.empty();
					searchRates.$domNoResults.addClass('active');
				}
			},
			complete: ()=>{
				searchRates.$domLoader.removeClass('active');
			}
		});
	}
};

export default searchRates;
